import axios from "axios";

export const baseBackend = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
